import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import App from './App.vue'
import axios from 'axios'

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Pusher from 'pusher-js'
window.Pusher = Pusher;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll);

Vue.prototype.$http = axios;

//Vue.config.devtools = true;
Vue.config.devtools = true;
Vue.config.productionTip = false;

import linkify from 'vue-linkify'
Vue.directive('linkified', linkify)

new Vue({
  render: h => h(App),
}).$mount('#chat');
